"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UndefinedRenderer {
    canRender(o) {
        return o === undefined;
    }
    render(ctx) {
        ctx.text("-");
    }
}
exports.default = UndefinedRenderer;
//# sourceMappingURL=UndefinedRenderer.js.map